import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ITable } from '../../../interfaces/table';
import { EditTableComponent } from '../../modals/edit-table/edit-table.component';
import { filter, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { TableService } from '../../../services/table/table.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IRestaurantInfo } from '../../../interfaces/restaurant';
import { AuthService } from '../../../services/auth/auth.service';
import { BehaviorSubject, fromEvent, interval } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnChanges {

  @ViewChild('batteryStatus', { static: true }) hoverElement!: ElementRef;
  @Input() table!: ITable;
  @Input() restaurant!: IRestaurantInfo;
  @Input() isEdited = false;
  @Input() selectedTables: Set<number> | undefined;

  @Output() selectedTablesChange = new EventEmitter<{event: boolean, id: number}>();

  public isWaiter: boolean | undefined;
  public updatedAt$ = new BehaviorSubject<string | null>(null);
  constructor(
    public auth: AuthService,
    public tables: TableService,
    private translate: TranslateService,
    private matDialog: MatDialog,
    private notifier: NotifierService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.restaurant && this.restaurant) {
      this.isWaiter = this.auth.isWaiter(this.restaurant);
    }
  }

  ngOnInit(): void {
    const mouseEnter$ = fromEvent(this.hoverElement.nativeElement, 'mouseenter');
    const mouseLeave$ = fromEvent(this.hoverElement.nativeElement, 'mouseleave');

    mouseEnter$.pipe(
      filter(() => !!this.table.batteryLevel.updatedAt),
      switchMap(() => interval(1000).pipe(
        startWith(0),
        tap(() => this.updatedAt$.next(this.table.batteryLevel.updatedAt)),
        takeUntil(mouseLeave$)
      )),
      untilDestroyed(this)
    ).subscribe();
  }

  cancelCalled(table: ITable): void {
    if (this.isEdited) { return; }

    if (table.status || table.statusMain) {
      return this.tables.cancelCalled(table);
    }

    if (table.statusPay || table.statusSecondary) {
      return this.tables.cancelCalledPay(table);
    }

    if (table.statusRepeat || table.statusTertiary) {
      return this.tables.cancelCalledRepeat(table);
    }
  }

  openTableEditModal(table: ITable): void {
    const tableSettings = this.matDialog.open(EditTableComponent, {
      data: {
        table
      },
      panelClass: 'settings-modal'
    });

    tableSettings.afterClosed().pipe(
      filter(Boolean),
    ).subscribe(() => {
      this.notifier.notify('success', this.translate.instant('pages.tables.messages.editedTable'));
    });
  }

  checkTables(event: boolean, id: number): void {
    this.selectedTablesChange.emit({event, id});
  }
}
